/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import axios from "axios";
import StickyHeaderTable from "reuseableTable";
import useRequestIdGenerater from "customhooks";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
} from "@mui/material";
import NoAviableData from "reuseableTable/NoAvailableData";
import { Form, Formik } from "formik";
import { PlayCircleOutline, SearchOutlined } from "@mui/icons-material";
import AnimatedLoader from "reuseableTable/AnimatedLoader";
import CachedIcon from "@mui/icons-material/Cached";
import useTimeStamp from "reuseableTable/uniquetimestamp/GenerateUniqueTimeStamp";
import DeleteIcon from "@mui/icons-material/Delete";
import VideoDetails from "./VideoDetails";
import moment from "moment";

const List = () => {
  const [pageData, setPageData] = useState([]);
  const [pageCache, setPageCache] = useState({});
  const [responseDetails, setResponseDetails] = useState({});
  const [showResponseDetails, setShowResponseDetails] = useState(false);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(11);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const RequestId = useRequestIdGenerater();
  const { rendomRequestId, generateTimeStamp } = useTimeStamp();

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedVideoId, setSelectedVideoId] = useState(null);

  const handleDeleteClick = (videoId) => {
    setSelectedVideoId(videoId);
    setOpenDialog(true);
  };

  const handleConfirmDelete = async () => {
    if (selectedVideoId) {
      try {
        await axios.delete(`/v1/alumni/video/delete/${selectedVideoId}`, {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem(
              "serviceToken"
            )}`,
            "Content-Type": "application/json",
            requestId: RequestId(
              page,
              Math.floor(1000 + Math.random() * 9999) + rendomRequestId
            ),
          },
        });

        fetchData();
        generateTimeStamp();
      } catch (error) {
        console.error("Error deleting video:", error);

        generateTimeStamp();
      }
    }
    setOpenDialog(false);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const columns = [
    {
      id: "videoCategory",
      label: "Category",
      minWidth: 100,
      align: "left",
      render: (row) => (
        <p style={{ margin: "0", fontWeight: "bold", color: "#143879" }}>
          {row?.videoCategory?.name || "N/A"}
        </p>
      ),
    },

    {
      id: "title",
      label: "Title",
      minWidth: 100,
      align: "left",
      render: (row) => (
        <p style={{ margin: "0", fontWeight: "bold", color: "#0056b3" }}>
          {row?.title || "N/A"}
        </p>
      ),
    },
    {
      id: "appliedDate",
      label: "Uploaded on",
      minWidth: 100,
      align: "center",
      render: (row) => (
        <div>
          <p>{moment(row?.appliedDate).format("DD/MM/YYYY")}</p>
        </div>
      ),
    },

    {
      id: "approvalStatus",
      label: "Status",
      minWidth: 80,
      align: "left",
      render: (row) => (
        <Chip
          size="small"
          sx={{
            backgroundColor:
              row.approvalStatus === "Pending"
                ? "#E7C1C1"
                : row.approvalStatus === "Approved"
                  ? "#D1F0BB"
                  : row.approvalStatus === "Rejected" && "#ECBEB2",
            color: "#000000",
          }}
          label={row?.approvalStatus}
        />
      ),
    },

    {
      id: "Video",
      label: "Video",
      minWidth: 50,
      align: "left",
      render: (row) => (
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          {row?.videoPath ? (
            <>
              <a
                // href={row?.videoPath}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  color: "#3a98ea",
                  fontWeight: "bold",
                }}
              >
                Watch Video
              </a>

              <IconButton
                onClick={() => getVideoDetails(row?.id)}
                color="primary"
              >
                <PlayCircleOutline fontSize="large" />
              </IconButton>
            </>
          ) : (
            "No Video"
          )}
        </div>

        // <IconButton >
        //     <VideoFileOutlinedIcon />
        // </IconButton>
      ),
    },
    {
      id: "action",
      label: "Action",
      minWidth: 60,
      align: "left",
      render: (row) => (
        <>
          <IconButton onClick={() => handleDeleteClick(row.id)} color="error">
            <DeleteIcon />
          </IconButton>
        </>
      ),
    },
  ];

  const fetchData = async (values, resetPage = false) => {
    setIsLoading(true);
    const currentPage = resetPage ? 0 : page;

    try {
      const response = await axios.get(`/v1/alumni/video/my`, {
        params: {
          approvalStatus: values?.careerStatus ?? "",
          pageNumber: currentPage,
          pageSize: rowsPerPage,
        },
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem(
            "serviceToken"
          )}`,
          "Content-Type": "application/json",
          requestId: RequestId(
            Math.floor(1000 + Math.random() * 9999),
            Math.floor(1000 + Math.random() * 9999) + rendomRequestId
          ),
        },
      });
      setPageData(response?.data?.data?.content);
      setTotalCount(response?.data?.data?.totalElements);
      setPageCache((prev) => ({
        ...prev,
        [currentPage]: response?.data?.data?.content,
      }));
      if (resetPage) {
        setPage(0);
      }
      setIsLoading(false);
      generateTimeStamp();
    } catch (error) {
      setIsLoading(false);
      generateTimeStamp();
      console.error("Failed to fetch data:", error);
    }
  };

  const getVideoDetails = async (videoId) => {
    try {
      const response = await axios.get(
        `/v1/alumni/video/detail?videoId=${videoId}`,
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem(
              "serviceToken"
            )}`,
            "Content-Type": "application/json",
            requestId: RequestId(
              Math.floor(1000 + Math.random() * 9999),
              Math.floor(1000 + Math.random() * 9999) + rendomRequestId
            ),
          },
        }
      );
      setResponseDetails(response?.data?.data);
      setShowResponseDetails(true);
      generateTimeStamp();
    } catch (error) {
      generateTimeStamp();
      console.error("Failed to fetch data:", error);
    }
  };

  useEffect(() => {
    if (pageCache[page]) {
      setPageData(pageCache[page]);
    } else {
      fetchData();
    }
  }, [page, rowsPerPage, pageCache]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const initialValues = {
    careerStatus: "",
  };

  useEffect(() => {
    generateTimeStamp();
  }, []);

  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => fetchData({ ...values, page, rowsPerPage }, true)}
      >
        {({ values, handleChange, setFieldValue, touched, errors }) => (
          <Form>
            <Grid container spacing={1} p={2}>
              <Grid item md={3} xs={12}>
                <FormControl fullWidth>
                  <InputLabel id="age-select">Status</InputLabel>
                  <Select
                    labelId="Batch-select"
                    id="careerStatus"
                    name="careerStatus"
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    value={values?.careerStatus}
                    label="Status"
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>

                    <MenuItem value="Pending">Pending</MenuItem>
                    <MenuItem value="Approved">Approved</MenuItem>
                    <MenuItem value="Rejected">Rejected</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item md={3} xs={12}>
                <Tooltip title={isLoading ? "Loading..." : "Search"}>
                  <IconButton
                    sx={{
                      color: "primary.main",
                      background: "primary.dark",
                      "& .MuiSvgIcon-root": { fontSize: "1.5rem" },
                    }}
                    size="large"
                    type="submit"
                  >
                    {isLoading ? <CachedIcon /> : <SearchOutlined />}
                  </IconButton>
                </Tooltip>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
      {isLoading ? (
        <AnimatedLoader />
      ) : (
        <>
          {pageData?.length > 0 ? (
            <Box sx={{ ml: 1.5 }}>
              <StickyHeaderTable
                data={pageData}
                count={totalCount}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                columns={columns}
              />
            </Box>
          ) : (
            <NoAviableData
              text={
                "At this time, data isn't available. To access it, Please Add videos."
              }
            />
          )}
        </>
      )}

      <VideoDetails
        open={showResponseDetails}
        setOpen={setShowResponseDetails}
        responseDetails={responseDetails}
      />
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this video? This action cannot be
            undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="error">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default List;
